import protectedAxiosRequest from '@/services/helpers/protectedAxiosRequest';

import config from '../utility/config';

const { communityApiBasePath } = config;

export const logEvent = (logData) => {
  protectedAxiosRequest
    .post(`${communityApiBasePath}/api/v1/communities/log`, logData)
    .then((response) => {
      if (!response.data) {
        throw new Error('Network response was not ok');
      }
    })
    .catch((error) => console.error('Error sending log event:', error));
};

const useLogEvent = () => {
  return logEvent;
};

export default useLogEvent;
